// extracted by mini-css-extract-plugin
module.exports = {"wjncibq":"wjncibq"};